import { useTranslation, useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Globe } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { t } = useTranslation();
  const { user, loading, language, switchLanguage } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#EFF2F7] flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8 animate-fade-in-up">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
            <img src="/images/logo_LP_carr.png" alt="LifePulse" className="w-14 h-14" />
          </div>
          <h1 className="text-2xl font-bold text-[#1E293B] mb-1">{t('auth.loginTitle')}</h1>
          <p className="text-sm text-[#64748B]">{t('auth.loginSubtitle')}</p>
        </div>

        <Card className="widget-card animate-fade-in-up animation-delay-100">
          <CardContent className="p-8">
            <Button
              onClick={handleGoogleLogin}
              className="w-full rounded-xl bg-white hover:bg-[#F8FAFC] text-[#1E293B] border border-[#E2E8F0] py-6 text-base font-semibold shadow-sm hover:shadow transition-all"
              data-testid="google-login-btn"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              {t('auth.google')}
            </Button>

            <div className="mt-6 text-center">
              <button
                onClick={() => switchLanguage(language === 'fr' ? 'en' : 'fr')}
                className="inline-flex items-center gap-1.5 text-xs text-[#94A3B8] hover:text-[#64748B] transition-colors"
                data-testid="login-lang-switch"
              >
                <Globe className="w-3.5 h-3.5" />
                {language === 'fr' ? 'Switch to English' : 'Passer en francais'}
              </button>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-[#94A3B8] mt-6">
          {language === 'fr'
            ? 'En vous connectant, vous acceptez nos conditions d\'utilisation.'
            : 'By signing in, you agree to our terms of service.'}
        </p>
      </div>
    </div>
  );
}
